<template>
  <label :for="switchId" class="fdd-checkbox">
    <input :id="switchId" type="checkbox" :checked="checked" @change="handleChange" />
    <span class="checkbox"></span>
    <span class="bg">
      <i>{{ activeText }}</i
      ><i>{{ inactiveText }}</i>
    </span>
  </label>
</template>
<script>
  export default {
    name: 'FddSwitch',
    props: {
      value: {
        type: [Boolean, String, Number],
        default: false
      },
      activeValue: {
        type: [Boolean, String, Number],
        default: true
      },
      inactiveValue: {
        type: [Boolean, String, Number],
        default: false
      },
      activeText: {
        type: String,
        default: '是'
      },
      inactiveText: {
        type: String,
        default: '否'
      }
    },
    computed: {
      switchId() {
        return `checkbox_${this._uid}`
      },
      checked() {
        return this.value === this.activeValue
      }
    },
    mounted() {
      if (!~[this.activeValue, this.inactiveValue].indexOf(this.value)) {
        this.$emit('input', this.inactiveValue)
      }
    },
    methods: {
      handleChange(e) {
        let value = this.checked ? this.inactiveValue : this.activeValue
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
</script>
